module.exports = __webpack_public_path__ + "media/app/images/podcast-icon-30b79349143fb74addfadb3b40722d3b.png";